export type Tag = {
  id?: number;
  name?: string;
  description?: string;
  image?: string;
  is_visible?: boolean;
};

export class TagClass implements Tag {
  id = 0;
  name = '';
  description = '';
  image = '';
  is_visible = false;
}
